<div class="orders py-3 pagination-order">
  <header
    class="orders-header d-flex align-items-center justify-content-between has-border pb-2 mb-4">
    <h1>Orders Written Report</h1>

    <div class="orders-panel col-auto d-flex justify-content-between">
      <div class="ms-3 nav-link p-0 dropdown d-flex align-items-center">
        <i class="icon-Export-excel me-2"></i>
        <a class="link" (click)="exportExcelFile()">Export excel</a>
      </div>
    </div>
  </header>

  <div class="p-wrapper-custom">
    <p-table
      #dt
      responsiveLayout="scroll"
      [value]="filterOrdersWrittenReportDetailLists"
      styleClass="p-datatable-customers"
      [rowHover]="true"
      [rows]="50"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 50, 1000]"
      [autoLayout]="true"
      [resizableColumns]="true"
      [paginator]="ordersWrittenReportDetailLists.length >= 20">
      <ng-template pTemplate="header">
        <tr>
          <th>Sale Order</th>
          <th>Created Date</th>
          <th>Client Name</th>
          <th>Job Name</th>
          <th>IHD</th>
          <th>Branding Consultant</th>
          <th>Account Coordinator</th>
          <th>Status</th>
          <th>Highest Net Vendor</th>
          <th>Currency</th>
          <th>Order Total</th>
          <th>Commission</th>
          <th>Net GP%</th>
          <th>Buyer</th>
          <th>Client PO</th>
        </tr>
        <tr>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="salesOrder"
                id="salesOrder"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'salesOrder', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <!-- <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                name="createdDate"
                id="createdDate"
                class="date-filter"
                onfocus="(this.type='date')"
                onblur="if(!this.value) this.type='text'"
                (change)="onCreatedDateFilter($event)"
              />
            </div> -->
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="customerName"
                id="customerName"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'customerName',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="jobName"
                id="jobName"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'jobName', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <!-- <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                name="inHandDate"
                id="inHandDate"
                class="date-filter"
                onfocus="(this.type='date')"
                onblur="if(!this.value) this.type='text'"
                (change)="onInHandDateFilter($event)"
              />
            </div> -->
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="brandingConsultant"
                id="brandingConsultant"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'brandingConsultant',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="accountCoordinator"
                id="accountCoordinator"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'accountCoordinator',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="status"
                id="status"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'status', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <!-- <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="highestNetVendor"
                id="highestNetVendor"
                style="max-width: 200px"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'highestNetVendor',
                    'startsWith'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component"
              />
            </div> -->
          </th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="buyer"
                id="buyer"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'buyer', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="clientPO"
                id="clientPO"
                style="max-width: 200px"
                (input)="
                  dt.filter($any($event.target).value, 'clientPO', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-ordersWrittenReportDetailList
        let-rowIndex="rowIndex">
        <tr class="p-selectable-row">
          <td>
            <a
              class="link"
              (click)="
                redirectToSaleorder(ordersWrittenReportDetailList.salesOrder)
              ">
              {{ ordersWrittenReportDetailList.salesOrder }}
            </a>
          </td>

          <td>
            <span
              *ngIf="
                ordersWrittenReportDetailList?.createdDate | hidedynamicsdate
              ">
              {{
                ordersWrittenReportDetailList.createdDate | date: "MM-dd-yyyy"
              }}
            </span>
          </td>
          <td>
            <a
              class="link"
              (click)="
                redirectToClient(ordersWrittenReportDetailList.customerId)
              ">
              {{ ordersWrittenReportDetailList.customerName }}
            </a>
          </td>
          <td>{{ ordersWrittenReportDetailList.jobName }}</td>
          <td>{{ ordersWrittenReportDetailList.ihd | date: "MM-dd-yyyy" }}</td>
          <td>{{ ordersWrittenReportDetailList.brandingConsultant }}</td>
          <td>
            {{ ordersWrittenReportDetailList.accountCoordinator }}
          </td>
          <td>
            {{ ordersWrittenReportDetailList.status }}
          </td>
          <td>
            <a
              class="link"
              (click)="
                redirectToVendor(ordersWrittenReportDetailList.vendorId)
              ">
              {{ ordersWrittenReportDetailList.highestNetVendor }}
            </a>
          </td>
          <td>
            {{ ordersWrittenReportDetailList.currency }}
          </td>
          <td>
            {{ ordersWrittenReportDetailList.orderSubTotal | currency }}
          </td>
          <td>
            {{ ordersWrittenReportDetailList.commission | currency }}
          </td>
          <td>
            {{ ordersWrittenReportDetailList.orderNetGP | number: "1.2-2" }}
          </td>
          <td>
            {{ ordersWrittenReportDetailList.buyer }}
          </td>
          <td>
            {{ ordersWrittenReportDetailList.clientPO }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="30">No Data Found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="vendorDisplayModal"
  [displayModal]="vendorDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Vendor Summary</h1>
  <div class="panelBody">
    <jni-vendor-summary
      [vendorIdFromModal]="vendorAccountNumber"
      (emitcloseVendorModalStacker)="closeModal()"></jni-vendor-summary>
  </div>
</jni-modal-stacker>
